<template>
  <div>
    <header-nav></header-nav>
    <banner-component :banner-data="articleListNav"></banner-component>
    <div class="content">
      <!--左-->
      <article-side-bar :article-list-nav="articleListNav"></article-side-bar>
      <!--右-->
      <div class="content_right">
        <div class="content_header">
          <span class="title">{{curName.plateName}}</span>
          <span
            class="card"
          >{{articleListNav.menuName}} > {{curName.plateName}} > {{articleDetail.name}}</span>
        </div>
        <div class="article_detail_box">
          <div class="article_title">{{articleDetail.name}}</div>
          <div class="date">
            <h2>所属院校机构：{{articleDetail.collegesName}}</h2>
            {{articleDetail.publishTime}}
          </div>
          <!-- <div class="article_content" v-html="articleDetail.content"></div> -->
          <iframe class="article_content" :src="articleDetail.pdfUrl" frameborder="0"></iframe>
          <p v-if="articleDetail.pdfUrl != null" class="download_file">
            附件:
            <a
              :href="articleDetail.pdfUrl"
              target="_blank"
            >{{articleDetail.pdfUrl}} &nbsp;&nbsp;&nbsp;&nbsp;点击下载</a>
          </p>
        </div>
      </div>
    </div>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue'
import CommonFooter from '@/components/CommonFooter.vue'
import PartnerList from '@/components/PartnerList.vue'
import BannerComponent from '@/components/BannerComponent.vue'
import { patentDetail } from "@/api/Patent.js";
import { queryArticleList, searchArticleList } from "@/api/ArticleList.js";
import ArticleSideBar from "@/components/ArticleSideBar.vue";
export default {
  components:{ArticleSideBar, HeaderNav, CommonFooter, PartnerList, BannerComponent},
//   props: {
//     articleListNav: Object
//   },
  data() {
    return {
      search: "",
      articleDetail: {}
    };
  },
  computed: {
    articleListNav: function () {
    let data = this.$store.state.app.static.find((item) => {
        return item.menuId == this.$route.query.menuId
    })
    return data
    },
    curName() {
      let name = this.articleListNav.children.find(item => {
        return item.id == this.$route.query.plateId;
      });
      return name;
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      patentDetail(
          {
            id: this.$route.query.id
          }
      ).then(res => {
        this.articleDetail = res;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// .article_content {
//   a {
//     font-size: inherit;
//     font-family: inherit;
//     color: inherit;
//   }
// }
</style>
<style lang="scss" scoped>
//$themeColor: #3e76fc;
.content {
  width: 1200px;
  display: flex;
  margin: 0 auto 120px auto;
  .content_right {
    width: 1112px;
    padding-left: 34px;
    .content_header {
      width: 100%;
      height: 86px;
      border-bottom: 1px solid $themeColor;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        width: 440px;
        font-size: 28px;
        color: $themeColor;
      }
      .card {
        font-size: 14px;
        color: #333;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align:right;
      }
    }
    .article_detail_box {
      width: 100%;
      .article_title {
        font-size: 22px;
        color: red;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .article_content {
        min-height: 300px;
        width: 100%;
        height: 1000px;
      }
      .download_file {
        margin-top: 30px;
        a {
          font-size: 14px;
          color: blue;
          text-decoration: underline;
        }
      }
      .date {
        font-size: 14px;
        color: #999;
        // display: flex;
        // justify-content: flex-end;
        margin: 15px 0;
        @include flex(center,space-between);
        h2{
          font-weight: 500;
          font-size: 20px;
          color: #333;
        }
      }
    }
  }
}
</style>
